import React, { useState, useMemo } from "react";
import { Typography, Grid2, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import SearchTextField from "@components/inputs/searchTextField";
import CustomButton from "@components/button/customButton";
import ConfirmDialog from "@components/dialog/confirmDialog";
import StatusChip from "@components/chip/statusChip";

export default function AuthorizedUserListing({ 
  addedUserListing,
  loading,
  disabled = false,
  handleOpenAddUserDialog,
  setAddedUserListing,
}) {
  const [search, setSearch] = useState("");

  const [checkedUser, setCheckedUser] = useState([])

  const [openDeleteConfirmDialog, setOpenDeleteConfirmDialog] = useState(false)

  const handleCheckboxChange = (checked) => {
    const selectedRow = checked.map((id) => addedUserListing.find((row) => row.userGuid === id));
    setCheckedUser(selectedRow)
  };

  // Function to delete checked user
  const handleDeleteUser = () => {
    setOpenDeleteConfirmDialog(true)
  }; 

  const onConfirmDeleteUser = () => {
    // Filter out the checked user from addedUserListing
    setAddedUserListing((prev) =>
      prev.filter(
        (user) => !checkedUser.some((checked) => checked.userGuid === user.userGuid)
      )
    );

    // Clear the checkedUser array after deletion
    setCheckedUser([]);
    setOpenDeleteConfirmDialog(false)
  }

  //==========================Search Function================================
  const handleFilterAuthorizedUserSearch = (user) => {
    var lowerCaseSearch = search?.toLowerCase() ?? "";
    return (
      user.fullName?.toLowerCase().includes(lowerCaseSearch) ||
      user.addBy?.toLowerCase().includes(lowerCaseSearch) 
    );
  };
  //==========================================================================

  const filteredAuthorizedUserDataList = useMemo(() => {
    return addedUserListing?.filter((a) => handleFilterAuthorizedUserSearch(a))
  }, [addedUserListing, search]);

  return (
    <Paper
      sx={{
        p: "20px 25px 0px 25px",
        boxShadow: "none",
        borderRadius: "10px",
        border: "1px solid #E5E5E5",
      }}
    >
      <Grid2 container spacing={'20px'}>
        <Grid2 size={12} >
          <Typography fontWeight={600} fontSize={"0.9rem"} color="#202020">
            Authorized User(s) Listing
          </Typography>
        </Grid2>
        <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }} >
          <SearchTextField
            value={search}
            setValue={setSearch}
          />
        </Grid2>
        {!disabled && 
        <Grid2 size={{ lg: 6, md: 12, sm: 12, xs: 12 }} display={'flex'} justifyContent={"flex-end"} gap={"10px"}>
          <CustomButton color="#D13F58" onClick={handleDeleteUser} disabled={checkedUser.length === 0}>Remove</CustomButton>
          <CustomButton onClick={handleOpenAddUserDialog}>Add</CustomButton>
        </Grid2>
        }
        <Grid2 size={12}>
          <DataGrid
            loading={loading}
            rows={filteredAuthorizedUserDataList}
            getRowId={(row) => row.userGuid}
            columns={[
              {
                field: 'fullName',
                headerName: 'Name',
                flex: 1, minWidth: 125,
              },
              {
                field: 'status',
                headerName: 'Status',
                flex: 1, minWidth: 100,
                renderCell: (params) => {
                  const statusText = params.row?.status ? "Active" : "Inactive"
                  return <StatusChip status={statusText} />
                },
              },
            ]}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[10,25,50]}
            disableRowSelectionOnClick
            disableColumnResize
            disableColumnMenu
            disableColumnSelector
            disableDensitySelector
            checkboxSelection={!disabled}
            onRowSelectionModelChange={handleCheckboxChange}
            sx={{ border: 0 }}
          />
        </Grid2>
      </Grid2>
      <ConfirmDialog 
        open={openDeleteConfirmDialog} 
        onClose={()=>setOpenDeleteConfirmDialog(false)} 
        dialogTitle="Remove User(s)" 
        dialogDescription="Are you sure you want to remove user(s)."
        onSubmit={onConfirmDeleteUser}
        items={checkedUser.map(user => user.fullName)}
      />
    </Paper>
  );
}